/**
 * Spanish copy for the errors the voice engine returns.
 *
 * The engine answers in English and the edge functions hand its `message`
 * straight to the caller, so whatever it says lands verbatim in a toast — a
 * customer saw "Credit balance exhausted, please top up to continue."
 *
 * Two things have to happen at this boundary. The known failures get real
 * Spanish copy that says what to do about them, and anything unrecognised at
 * least stops naming the vendor: the product calls it "el motor de voz" and
 * never Retell, including in an error nobody wrote on purpose.
 */

const KNOWN: Array<{ pattern: RegExp; message: string }> = [
  {
    pattern: /credit balance|top ?up|insufficient (credits?|balance|funds)/i,
    message:
      "Tu cuenta del motor de voz se quedó sin saldo. Recárgala para volver a hacer llamadas.",
  },
  {
    pattern: /invalid api ?key|invalid authentication|unauthorized|forbidden/i,
    message:
      "La clave del motor de voz no es válida o fue revocada. Revísala en la configuración del módulo.",
  },
  {
    pattern: /rate ?limit|too many requests/i,
    message: "El motor de voz recibió demasiadas solicitudes. Espera unos segundos y vuelve a intentarlo.",
  },
  {
    pattern: /last\s+source/i,
    message:
      "No se puede borrar el único archivo de una base de voz. Sube otro antes de borrarlo, o elimina la base completa.",
  },
  {
    pattern: /concurrency/i,
    message: "Se alcanzó el límite de llamadas simultáneas del motor de voz.",
  },
  {
    // A cloned voice lives in the account that holds it, so an export moved to
    // another workspace names one this account has never seen.
    pattern: /voice\b[^.]*\bnot found\b/i,
    message:
      "La voz clonada del archivo pertenece a otra cuenta del motor de voz y no está disponible aquí. " +
      "Importa el agente y elígele una voz de este espacio de trabajo.",
  },
];

/** "Retell API error 502", the client's own fallback when the body carries no message. */
const GENERIC = /^Retell API error (\d{3})$/i;

export function voiceEngineErrorMessage(raw: string | null | undefined): string {
  if (!raw?.trim()) return "Error desconocido";

  for (const { pattern, message } of KNOWN) {
    if (pattern.test(raw)) return message;
  }

  const generic = raw.match(GENERIC);
  if (generic) {
    return `El motor de voz respondió con un error (${generic[1]}). Vuelve a intentarlo en unos minutos.`;
  }

  return raw.replace(/\bretell(\s*ai)?\b/gi, "el motor de voz");
}
